module.exports = __webpack_public_path__ + "static/media/estateblur2.26ce6435.jpg";